<template>
  <div>
    <el-upload
      class="avatar-uploader"
      action
      :show-file-list="false"
      :on-success="handleSuccess"
      :before-upload="beforeUpload"
      :headers="headers"
      :data="uploadData"
      :file-list="images"
      :http-request="upload"
    >
      <img v-if="imageUrl" :src="imageUrl" class="avatar" :style="'width:'+width+'px'" />
      <i v-else class="el-icon-plus avatar-uploader-icon" :style="'width:'+width+'px'"></i>
    </el-upload>
    <el-button @click="onShowImage">选择图片</el-button>
    <el-button @click="onShowDialog">网络图片</el-button>
    <image-list ref="imageList" @selected="onSelectedImage"></image-list>
    <el-dialog title="图片地址" :visible.sync="dialogFormVisible">
      <el-input v-model="imageUrl" autocomplete="off"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="onOk">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
let OSS = require("ali-oss");

import lrz from "lrz";
import qs from 'qs';

import { getToken } from "../../config/cache";
import imageList from "./image_lists.vue";
export default {
  name: "upload",
  components: { imageList },
  props: {
    size: {
      type: Number,
      default: 1
    },
    images: {
      type: Array,
      default: []
    },
    width: {
      type: Number,
      default: 146
    }
  },
  data() {
    return {
      dialogFormVisible:false,
      upload_url: `${this.$config.api_url}admin/image/upload`,
      dialogVisible: false,
      imageUrl: "",
      uploadData: {},
    };
  },
  computed: {
    headers() {
      const token = getToken(); //获取本地token
      return { Authorization: token };
    }
  },

  methods: {
    //覆盖默认的上传行为，自定义上传的实现
    upload(file) {
      var self = this;
      this.$http.get("/admin/oss").then(res => {
        if (res.code == 200) {
          self.ossupload(file, res.data);
        }
      });
    },
    onShowDialog(){
      this.dialogFormVisible = true;
    },
    onOk(){
      this.dialogFormVisible = false;
      this.$emit("success",{path:this.imageUrl});
    },
    //上传
    ossupload(file, params) {
      const self = this;

      let client = new OSS({
        region: params.region,
        accessKeyId: params.accessKeyId,
        accessKeySecret: params.accessKeySecret,
        bucket: params.bucket,
        secure: true
      });

      let file_name = self.getObjectKey('web/',file.file);
      client
        .multipartUpload(file_name, file.file, {
          progress: function(p) {
            //p进度条的值
            console.log(Math.floor(p * 100));
          }
        })
        .then(result => {
          //上传成功返回值，可针对项目需求写其他逻辑
          let fname = result.name;
          self.imageUrl = result.res.requestUrls[0];
          self.$emit("success", {path:self.imageUrl});
          self.saveImage(fname,self.imageUrl);
        })
        .catch(err => {
          self.$message.error("上传失败，请重试。");
          console.log("err:", err);
        });
    },

    saveImage(name,imageurl)
    {
      this.$http.post("/admin/oss/save",{name:name,url:imageurl}).then(res=>{
        console.log("result:",res);
      })
    },
    onShowImage()
    {
      this.$refs.imageList.show();
    },
    onSelectedImage(value)
    {
      this.imageUrl = value.path;
      this.$emit("success", value);
    },
    async beforeUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt500K = file.size / 1024 / 1024 < this.size;
      console.log("name:", file.name);
      this.uploadData = { name: file.name };
      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      if (!isLt500K) {
        this.$message.error("上传头像图片大小不能超过 500K!");
      }
      let promise = new Promise(resolve => {
        this.$nextTick(function() {
          resolve(true);
        });
      });
      return promise;
    },
    handleSuccess(response, file, fileList) {
      if (response.code == 200) {
        this.imageUrl = response.data.path;
        this.$emit("success", response.data);
      } else {
        this.images = [];
        this.$message.error(response.msg);
      }
    },
    handlePreview(file) {
      this.imageUrl = file.url;
      this.dialogVisible = true;
    },

    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    setImage(file) {
      if (file) {
        this.imageUrl = file.url;
        this.images = [file];
      } else {
        this.imageUrl = "";
        this.images = [];
      }
    },
    /**
     * 获取随机字符串
     * @param {*} len 长度
     */
    randomString(len) {
        len = len || 32
        const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
        const maxPos = chars.length
        let pwd = ''
        for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
        }
        return pwd
    },
    getObjectKey(dir, file) {
        return `${dir}${this.randomString(
        8
        )}_${new Date().getTime()}.${file.name.split('.').pop()}`
    },
  }
};
</script>

<style lang="less">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background: #f0f0f0;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.avatar {
  width: 146px;
  height: 146px;
  display: block;
}
</style>